export default {"src":"/_next/static/media/why-one-branches-icon.36cbc238.svg","height":66,"width":73,"blurWidth":0,"blurHeight":0};